"use client";

import React, { useEffect, useRef, useState } from "react";
import { Tabs, TabsItem } from "daskapital-ds";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";

export type IBlockTabs = {
  attrs: {
    title?: string;
    vertical?: boolean;
    mode?: string;
    updateUrl?: boolean;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: BlocksProps[];
};
export default function BlockTabs({ attrs, innerBlocks }: IBlockTabs) {
  const { mode, updateUrl, className } = attrs || {};

  const [hash, setHash] = useState("");

  useEffect(() => {
    setHash(window.location.hash.slice(1));
  }, []);

  const activeElement = innerBlocks.findIndex(x => x?.attrs?.anchor === hash);

  const wrapperRef = useRef<HTMLDivElement>(null);

  // the DS Tabs never calls a TabsItem's onClick (it reads item.onClick
  // instead of item.props.onClick), so the click on a tab is caught here
  // instead - only on an <li> of this Tabs' own nav, so tabs nested inside
  // a panel don't count. replaceState rather than pushState: switching tabs
  // shouldn't fill the back button's history, and it doesn't scroll the page
  const onTabsClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const nav = wrapperRef.current?.firstElementChild?.firstElementChild;
    const tab = (event.target as Element).closest("li");
    if (!nav || !tab || tab.parentElement !== nav) return;

    const index = Array.from(nav.children).indexOf(tab);
    const anchor = innerBlocks[index]?.attrs?.anchor as string | undefined;
    const { pathname, search } = window.location;
    window.history.replaceState(window.history.state, "", `${pathname}${search}${anchor ? `#${anchor}` : ""}`);
  };

  const tabs = (
    <Tabs mode={mode} $activeEl={activeElement === -1 ? 0 : activeElement} className={className}>
      {!!innerBlocks?.length &&
        innerBlocks.map((item: BlocksProps, index: number) => {
          const attrs = item?.attrs as Record<string, unknown>;
          return (
            <TabsItem key={`tabs-item${index}`} label={attrs.title as string}>
              {!!item?.innerBlocks?.length &&
                item?.innerBlocks?.map((block: BlocksProps, index: number) => {
                  return displayBlock(block, index);
                })}
            </TabsItem>
          );
        })}
    </Tabs>
  );

  if (!updateUrl) return tabs;

  return (
    <div ref={wrapperRef} onClick={onTabsClick} style={{ display: "contents" }}>
      {tabs}
    </div>
  );
}
